export default __webpack_public_path__ + "static/media/heigh.7035c7e7.png";